import React, { useState, useCallback } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { json as jsonLang } from '@codemirror/lang-json';
import { PerfectScrollbar } from '../ReactPerfectScrollbar';
import { CopyIcon } from 'components/icons';
import styles from './JsonViewer.module.css';

const JSONViewer = ({ jsonData }) => {
  const [copied, setCopied] = useState(false);
  const jsonString = JSON.stringify(jsonData, null, 2);

  const handleCopyClick = useCallback(() => {
    navigator.clipboard.writeText(jsonString);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  }, [jsonString]);

  return (
    <div className={styles.root}>
      <button className={styles.copyBtn} onClick={handleCopyClick}>
        <CopyIcon />
        <div className={styles.copyStatus}>{copied ? 'Copied!' : 'Copy to Clipboard'}</div>
      </button>
      <PerfectScrollbar options={{ wheelPropagation: false }}>
        <CodeMirror value={jsonString} theme={'dark'} extensions={[jsonLang()]} editable={false} readOnly={true} />
      </PerfectScrollbar>
    </div>
  );
};
export default JSONViewer;
